class PdpFeaturedReviewCta {
  constructor(button) {
    this.button = button;
    this.onClick = this.onClick.bind(this);
  }

  init() {
    this.button.addEventListener('click', this.onClick);
  }

  onClick() {
    const reviewsEl =
      document.querySelector('[data-oke-widget]') || document.querySelector('[data-oke-reviews-widget]');
    if (!reviewsEl) return;

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const top = reviewsEl.getBoundingClientRect().top + window.scrollY + 100;
    window.scrollTo({ top, behavior: prefersReduced ? 'auto' : 'smooth' });
  }
}

function initPdpFeaturedReviewCta() {
  document.querySelectorAll('[data-featured-review-cta]').forEach((button) => {
    new PdpFeaturedReviewCta(button).init();
  });
}

initPdpFeaturedReviewCta();
document.addEventListener('shopify:section:load', initPdpFeaturedReviewCta);
